module.exports = __webpack_public_path__ + "img/classic.acb87f6f.png";